import React from 'react';
import { Snackbar, Alert } from '@mui/material';

interface ResponseAlertProps {
    open: boolean;
    onClose: () => void;
    type: 'success' | 'error' | 'warning' | 'info';
    message: string;
    horizontal?: 'left' | 'right';
}

const ResponseAlert: React.FC<ResponseAlertProps> = ({ open, onClose, type, message, horizontal = 'right' }) => {
    return (
        <Snackbar
            open={open}
            onClose={onClose}
            sx={{ zIndex: 1300, elevation: 1300, position: 'fixed' }}
            autoHideDuration={6000}
            anchorOrigin={{ vertical: 'bottom', horizontal }}
        >
            <Alert onClose={onClose} severity={type} sx={{ width: '100%', zIndex: 1300 }}>
                {message}
            </Alert>
        </Snackbar>
    );
}

export default ResponseAlert;
